import { CursorPaginationResult } from "@/types/CursorPaginationResult";
import { Axios } from "@/utils/axios";
import { Question } from "./getQuestions";

export const getQuestionsSearch = (keyword: string | undefined) => {
  return async ({ pageParam = "" }) => {
    const page = pageParam ? new URL(pageParam).searchParams.get("page") : undefined;

    const { data } = await Axios.get<CursorPaginationResult<Question>>("/questions/search/", {
      params: {
        page,
        query: keyword,
      },
    });
    return data;
  };
};
